import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext.tsx';
import { useCloseOnEscape } from '../hooks/useCloseOnEscape.ts';
import './css/PremiumRequiredModal.css';

interface PremiumRequiredModalProps {
  onClose: () => void;
}

export function PremiumRequiredModal({ onClose }: PremiumRequiredModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToSubscription = () => {
    onClose();
    navigate('/subscription');
  };

  useCloseOnEscape(true, onClose);

  return (
    <div className="premium-required-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="premium-required-title">
      <div className="premium-required-modal" onClick={(e) => e.stopPropagation()}>
        <div className="premium-required-header">
          <span className="premium-required-icon" aria-hidden>🔒</span>
          <h3 id="premium-required-title">{t('premiumRequired.title')}</h3>
          <button type="button" className="premium-required-close" onClick={onClose} aria-label={t('premiumRequired.close')}>×</button>
        </div>
        <p className="premium-required-message">{t('premiumRequired.message')}</p>
        <div className="premium-required-actions">
          <button type="button" className="premium-required-btn premium-required-btn-close" onClick={onClose}>
            {t('premiumRequired.close')}
          </button>
          <button type="button" className="premium-required-btn premium-required-btn-subscribe" onClick={handleGoToSubscription}>
            {t('premiumRequired.goToSubscription')}
          </button>
        </div>
      </div>
    </div>
  );
}
